import React, { useState } from 'react';
import { baseUrl, ROUTE_BASE_URL } from '../../../api/common';
import { encryptSlug } from "../../../util/encryption"

const CheckInChooseModal = ({ isOpen, onClose, checkinId }) => {

  const [selectedMethod, setSelectedMethod] = useState('web');
  const [copied, setCopied] = useState(false);
  
  const checkInUrl = `${baseUrl}/events/attendees-checkin-list/${encryptSlug(`${checkinId}`)}`;

  if (!isOpen) return null;

  const handleCopy = () => {
    window.open(checkInUrl, '_blank');
    // navigator.clipboard.writeText(checkInUrl);
    // setCopied(true);
    // setTimeout(() => setCopied(false), 2000);
  };

  const methods = [
    // { id: 'ios', label: 'iOS app', icon: '🍎' },
    { id: 'android', label: 'Android app', icon: <svg data-v-6f029f02="" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="android" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-android fa-fw fa-2x"><path data-v-6f029f02="" fill="currentColor" d="M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55" class=""></path></svg> },
    { id: 'web', label: 'Web check-in', icon: <svg data-v-6f029f02="" aria-hidden="true" focusable="false" data-prefix="far" data-icon="globe-americas" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" class="svg-inline--fa fa-globe-americas fa-fw fa-2x"><path data-v-6f029f02="" fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-32 50.8v11.3c0 11.9-12.5 19.6-23.2 14.3l-24-12c14.9-6.4 30.7-10.9 47.2-13.6zm32 369.8V456c-110.3 0-200-89.7-200-200 0-29.1 6.4-56.7 17.6-81.7 9.9 14.7 25.2 37.4 34.6 51.1 5.2 7.6 11.2 14.6 18.1 20.7l.8.7c9.5 8.6 20.2 16 31.6 21.8 14 7 34.4 18.2 48.8 26.1 10.2 5.6 16.5 16.3 16.5 28v32c0 8.5 3.4 16.6 9.4 22.6 15 15.1 24.3 38.7 22.6 51.3zm42.7 22.7l17.4-46.9c2-5.5 3.3-11.2 4.8-16.9 1.1-4 3.2-7.7 6.2-10.7l11.3-11.3c8.8-8.7 13.7-20.6 13.7-33 0-8.1-3.2-15.9-8.9-21.6l-13.7-13.7c-6-6-14.1-9.4-22.6-9.4H232c-9.4-4.7-21.5-32-32-32s-20.9-2.5-30.3-7.2l-11.1-5.5c-4-2-6.6-6.2-6.6-10.7 0-5.1 3.3-9.7 8.2-11.3l31.2-10.4c5.4-1.8 11.3-.6 15.5 3.1l9.3 8.1c1.5 1.3 3.3 2 5.2 2h5.6c6 0 9.8-6.3 7.2-11.6l-15.6-31.2c-1.6-3.1-.9-6.9 1.6-9.3l9.9-9.6c1.5-1.5 3.5-2.3 5.6-2.3h9c2.1 0 4.2-.8 5.7-2.3l8-8c3.1-3.1 3.1-8.2 0-11.3l-4.7-4.7c-3.1-3.1-3.1-8.2 0-11.3L264 112l4.7-4.7c6.2-6.2 6.2-16.4 0-22.6l-28.3-28.3c2.5-.1 5-.4 7.6-.4 78.2 0 145.8 45.2 178.7 110.7l-13 6.5c-3.7 1.9-6.9 4.7-9.2 8.1l-19.6 29.4c-5.4 8.1-5.4 18.6 0 26.6l18 27c3.3 5 8.4 8.5 14.1 10l29.2 7.3c-10.8 84-73.9 151.9-155.5 169.7z" class=""></path></svg> },
    // { id: 'badge', label: 'Badgy', icon: '🎫' }
  ];

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          width: '90%',
          maxWidth: '700px',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          padding: '20px 24px',
          borderBottom: '1px solid #e5e7eb',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>CHECK-IN APPS</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#6b7280',
              padding: '0',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '24px' }}>
          {/* <p style={{ 
            marginBottom: '24px', 
            color: '#374151',
            lineHeight: '1.6'
          }}>
            You can use as many check-in methods as you need on the day of your event.
          </p> */}

          {/* Step 1 */}
          <h3 style={{ 
            fontSize: '16px', 
            fontWeight: 600, 
            marginBottom: '16px',
            color: '#111827'
          }}>
            Step 1. Choose your check-in method
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: '12px',
            marginBottom: '32px'
          }}>
            {methods.map((method) => (
              <button
                key={method.id}
                onClick={() => setSelectedMethod(method.id)}
                style={{
                  padding: '20px',
                  border: selectedMethod === method.id ? '2px solid #3b82f6' : '1px solid #d1d5db',
                  borderRadius: '8px',
                  backgroundColor: selectedMethod === method.id ? '#eff6ff' : 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.2s'
                }}
              >
                <span style={{ fontSize: '32px' }}>{method.icon}</span>
                <span style={{ 
                  fontSize: '14px', 
                  fontWeight: 500,
                  color: '#374151'
                }}>
                  {method.label}
                </span>
              </button>
            ))}
          </div>

          {/* Step 2 - Web Check-in */}
          {selectedMethod === 'web' && (
            <>
              <h3 style={{ 
                fontSize: '16px', 
                fontWeight: 600, 
                marginBottom: '16px',
                color: '#111827'
              }}>
                Step 2. Use or share this URL
              </h3>

              <div style={{
                display: 'flex',
                gap: '8px',
                marginBottom: '16px'
              }}>
                <input
                  type="text"
                  value={checkInUrl}
                  readOnly
                  style={{
                    flex: 1,
                    padding: '10px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: '#f9fafb'
                  }}
                />
                <button
                  onClick={handleCopy}
                  style={{
                    padding: '10px 16px',
                    border: '1px solid #3b82f6',
                    borderRadius: '6px',
                    backgroundColor: 'white',
                    color: '#3b82f6',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '14px',
                    fontWeight: 500
                  }}
                >
                  {/* <Copy size={16} /> */}
                  <svg data-v-6f029f02="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="external-link-square" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-external-link-square fa-fw fa-1x"><path data-v-6f029f02="" fill="currentColor" d="M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-64 47.111C384 109.929 370.071 96 352.889 96H220.667c-12.887 0-23.333 10.447-23.333 23.334v14.904c0 13.138 10.843 23.686 23.976 23.324l56.002-1.588L69.908 361.908c-7.858 7.802-7.88 20.504-.05 28.334l19.899 19.899c7.83 7.83 20.532 7.808 28.334-.05l205.935-207.404-1.588 56.003c-.362 13.133 10.186 23.976 23.324 23.976h14.904c12.887 0 23.334-10.447 23.334-23.333V127.111z" class=""></path></svg>
                  {copied ? 'Copied!' : ''}
                </button>
              </div>
            </>
          )}

          {/* Step 3 - Android App Setup */}
          {selectedMethod === 'android' && (
            <>
              <h3 style={{ 
                fontSize: '16px', 
                fontWeight: 600, 
                marginTop: '32px',
                marginBottom: '16px',
                color: '#111827'
              }}>
                Step 2. Download the app
              </h3>
              
              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '32px'
              }}>
                <p style={{ margin: 0, color: '#374151' }}>
                  This app requires Android 4.4 and up.
                </p>
                <a 
                  href="https://play.google.com/store" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ display: 'block' }}
                >
                  <img 
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                    alt="Get it on Google Play"
                    style={{ height: '40px' }}
                  />
                </a>
              </div>

              <h3 style={{ 
                fontSize: '16px', 
                fontWeight: 600, 
                marginBottom: '16px',
                color: '#111827'
              }}>
                Step 3. Set-up the app
              </h3>

              <p style={{ marginBottom: '16px', color: '#374151' }}>
                There are two ways of setting up the app:
              </p>

              <div style={{ 
                display: 'flex',
                gap: '24px',
                marginBottom: '24px'
              }}>
                <div style={{ flex: 1 }}>

                  <p style={{ 
                    fontWeight: 600, 
                    marginTop: '20px',
                    marginBottom: '8px',
                    color: '#111827'
                  }}>
                    Set up with QR code:
                  </p>
                  <p style={{ 
                    fontSize: '14px', 
                    color: '#374151',
                    lineHeight: '1.6'
                  }}>
                    Scan the check-in list QR code with the app (not your camera). You can set up multiple 
                    devices yourself by scanning the QR code or drag and drop the QR code image to share it with others.
                  </p>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px 24px',
          borderTop: '1px solid #e5e7eb',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 20px",
              backgroundColor: "#184778",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#0f3554";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#184778";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckInChooseModal;